import { Color } from "rsuite/esm/internals/types/colours";

export interface BaseResponseModel<T> {
  result: T;
  success: boolean;
  errorMessage: string;
}

export class PaginationFilterRequest {
  pageNumber=1;
  pageSize= 30;
  orderBy?: string = "CreatedAt";
  isAscending = false;
  keyword?: string;
}
export const defaultPaginationFilterRequest = {
  pageNumber: 1,
  pageSize: 30,
  orderBy: "CreatedAt",
  isAscending: false,
  keyword: undefined
};

export class PaginationFilterResult {
  pageNumber=1;
  pageSize= 30;
  totalRecords= 0;
}

export interface PagedResponseModel<T> {
  result: T[];
  success: boolean;
  errorMessage: string;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export interface BaseErrorModel {
  success: boolean;
  errorMessage: string;
  errorCode: number;
  errors?: { [field: string]: string[] };
  // errors?: [];
}

export interface BaseLookupModel {
  id: number;
  name: string;
  localName: string;
  image?: string
}

export interface SelectModel {
  label: string;
  value: number;
}

export interface PaginatedSelectModel {
  data: SelectModel[];
  isLastPage: boolean;
}
export const emptyPaginatedSelectModel : PaginatedSelectModel = {
  data: [],
  isLastPage: true
};

export interface StatusInfoModel extends SelectModel {
  color: Color | React.CSSProperties['color'];
}

export const DateTimeFormatOptions : Intl.DateTimeFormatOptions =
{
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
};
export const DateFormatOptions : Intl.DateTimeFormatOptions =
{
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export enum PageState {
  New,
  Edit,
  readOnly
} 

export interface LatLng {
  lat: number,
  lng: number
}
export interface UpsertLatLng {
  lat?: number ,
  lng?: number
}